module.exports = __webpack_public_path__ + "img/baixiangfeng.d7177be6.jpg";